module.exports = __webpack_public_path__ + "media/images/icon__infoBox--rb-gray@2x-1cd0dec0b6d7e8fb47953d45209bc6ef.png";